// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3TcH4","file":"styles_file__1kpEs"};